import api from '@/api/fetch'
import { FloorplanDto } from '@/types'

export function getFloorplans() {
  return api
    .get<Record<string, FloorplanDto>>('/floorplans')
    .then(res => res.data)
}
